import { studentRequests } from "api/studentApi";
import { Button, useNotify } from "react-admin";

import dataProvider from "server/dataProvider";
import { Delete } from "@mui/icons-material";
import ConfirmModal from "server/components/Modals/ConfirmModal";

const DeletePersonalDocumentsPhotoModal = ({ studentId, id, side, fetchData }) => {
  const notify = useNotify();

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      studentRequests.deleteStudentPersonalDocuments({
        studentId,
        documentId: id,
        side,
      }),
      {},
      "DELETE",
    );

    await fetchData();
    notify("Успешно премахнат документ", {
      type: "success",
    });
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent="Изтриване на документ за самоличност"
      message="Сигурни ли сте , че искате да премахнете този документ?"
      triggerButton={
        <Button
          label="Изтрий"
          variant="contained"
          startIcon={<Delete />}
          sx={{ width: "max-content" }}
        />
      }
    />
  );
};

export default DeletePersonalDocumentsPhotoModal;
